// serivces/AuthService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";
// LOGIN
// `identifier` : matricule (étudiants) ou e-mail (autres profils)
export function login(identifier, password) {
    return api.post(ENDPOINTS.AUTH.LOGIN, {
        identifier,
        password
    });
}

export function checkAutoLogin() {

    const data = localStorage.getItem("userDetails");

    if (!data) return null;


    try {

        const parsed = JSON.parse(data);


        if (!parsed?.accessToken) {
            return null;
        }


        return {
            ...parsed,
            user: {
                ...parsed.user,
                roles: parsed.user?.roles || [],
                permissions: parsed.user?.permissions || []
            }
        };


    } catch {

        return null;

    }
}

// REGISTER
export function signUp(email, password, first_name, last_name) {
    return api.post(ENDPOINTS.AUTH.REGISTER, {
        email,
        password,
        first_name,
        last_name
    });
}

// GET PROFILE
export function getProfile() {
    return api.get(ENDPOINTS.AUTH.ME);
}

// REFRESH TOKEN
export function refreshAccessToken(refreshToken) {
    return api.post(ENDPOINTS.AUTH.REFRESH, {
        refreshToken
    });
}

// CHANGE PASSWORD
export function changePassword(currentPassword, newPassword) {
    return api.patch(ENDPOINTS.AUTH.CHANGE_PASSWORD, {
        currentPassword,
        newPassword
    });
}

// LOGOUT (backend invalidate token)
export function logoutRequest(refreshToken) {
    return api.post(ENDPOINTS.AUTH.LOGOUT, {
        refreshToken
    });
}

// STORAGE
export function saveTokenInLocalStorage(data) {
    const session = {
        ...data,
        expiresAt: Date.now() + (data.expiresIn || 3600) * 1000
    };

    localStorage.setItem("userDetails", JSON.stringify(session));
}